import { Load } from "./tracker"
import { Order } from "./taker"

export * from "./hooks"
export { useGetInvoker } from "./common"
export type LoadWithOrderState =
  | (Load & { isOrder?: false })
  | (Omit<Load, "state"> & { state: Order["state"]; isOrder: true })
